module.exports = __webpack_public_path__ + "img/wise-logo.e448d824.svg";